import { forwardRef } from "react";

export const Row = forwardRef(function Row(
  {
    children,
    className = "",
    gap = 2,
    justify = "center",
    items = "center",
    direction = "row",
    ...rest
  },
  ref
) {
  return (
    <div
      ref={ref}
      {...rest}
      className={`flex flex-${direction} items-${items} justify-${justify} gap-${gap} ${className}`}
    >
      {children}
    </div>
  );
});
